import {
  EDIT_DOCTOR, DELETE_DOCTOR, CREATE_DOCTOR, CREATE_DOCTOR_SUCCESS, UPDATE_DOCTOR_SUCCESS,
  UPDATE_DOCTOR, DELETE_DOCTOR_SUCCESS, FETCH_ALL_DOCTOR, FETCH_ALL_DOCTOR_SUCCESS, SET_DOCTOR, SET_ROLE,
  SET_DOCTOR_MULTI, DOCTOR_POPUP_STATUS_CHANGE, INIT_DOCTOR, 
  FETCH_ALL_DOCTOR_NAMES, 
  FETCH_ALL_DOCTOR_NAMES_SUCCESS,
  COPY_DOCTOR_TO_GEN2,
  COPY_DOCTOR_TO_GEN2_STATUS,
  COPY_DOCTOR_TO_GEN2_STATUS_CLEAR,
  DOCTOR_SEND_SMS, 
  DOCTOR_SMS_RESULT,
  CREATE_DOCTOR_ONBOARD_URL,
  COPY_DOCTOR_ONBOARD_URL,
  CLEAR_DOCTOR_ONBOARD_URL,
  FILTER_DOCTORS,
  FILTER_DOCTORS_SUCCESS,
  UPDATE_EXCLUDE_DOCTORS_FOR_DOCTOR_REPORTS,
  UPDATE_DOCTOR_STATUS,
  UPDATE_DOCTOR_STATUS_SUCCESS,
  UPDATE_DOCTOR_ACCOUNT_STATUS,
} from 'constants/doctors.constants'
import { startLoader } from 'actions/general.action';

export const setDoctor = (key, value) => {
  return {
    type: SET_DOCTOR,
    key: key,
    value: value
  }
}
export const setDoctorMultiple = (value) => {
  return {
    type: SET_DOCTOR_MULTI,
    value: value
  }
}

export const setRoles = (key, value) => {
  return {
    type: SET_ROLE,
    key: key,
    value: value
  }
}

export const fetchDoctors = (page) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_DOCTOR,
      payload: page
    });
    dispatch(startLoader());
  }
}

export const fetchDoctorsSuccess = (data) => {
  return {
    type: FETCH_ALL_DOCTOR_SUCCESS,
    payload: data
  };
};

export const deleteDoctor = (id) => {
  return {
    type: DELETE_DOCTOR,
    payload: id
  };
};

export const editDoctor = (id) => {
  return dispatch => {
    dispatch({
      type: EDIT_DOCTOR,
      payload: id
    })
    dispatch(startLoader());
  }
};

export const createDoctor = (payload) => {
  return dispatch => {
    dispatch({
      type: CREATE_DOCTOR,
      payload: payload
    })
    dispatch(startLoader())
  }
};

export const createDoctorSuccess = (payload) => {
  return {
    type: CREATE_DOCTOR_SUCCESS,
    payload: payload
  };
};

export const updateDoctorSuccess = (data) => {
  return {
    type: UPDATE_DOCTOR_SUCCESS,
    payload: data
  };
};

export const deleteDoctorSuccess = (data) => {
  return {
    type: DELETE_DOCTOR_SUCCESS,
    payload: data
  };
};

export const updateDoctor = (payload) => {
  return dispatch => {
    dispatch({
      type: UPDATE_DOCTOR,
      payload: payload
    })
    dispatch(startLoader())
  }
};
export const openViewPopup = (data) => {
  return {
    type: DOCTOR_POPUP_STATUS_CHANGE,
    payload: data,
  };
};

export const initDoctor = (data) => {
  return {
    type: INIT_DOCTOR,
    payload: data,
  };
};

export const sendSMSDoctor = (payload) => {
  return {
    type: DOCTOR_SEND_SMS,
    payload: payload
  };
};

export const  sendSMSResult  = (payload) => {
  return {
    type: DOCTOR_SMS_RESULT,
    payload: payload
  };
};

export const fetchDoctorNameList = (payload = null) => {
  return dispatch => {
    dispatch({
      type: FETCH_ALL_DOCTOR_NAMES,
      payload: payload
    });
  }
}

export const fetchDoctorNamesSuccess = (data) => {
  return {
    type: FETCH_ALL_DOCTOR_NAMES_SUCCESS,
    payload: data
  };
};

export const copyDoctorToGen2 = (payload) => {
  return {
    type: COPY_DOCTOR_TO_GEN2,
    payload: payload,
  };
};

export const copyDoctorToGen2Status = (payload) => {
  return {
    type: COPY_DOCTOR_TO_GEN2_STATUS,
    payload: payload,
  };
};

export const copyDoctorToGen2StatusClear = () => {
  return {
    type: COPY_DOCTOR_TO_GEN2_STATUS_CLEAR,
  };
};

export const generateDoctorOnboardingURL = () => {
  return {
    type: CREATE_DOCTOR_ONBOARD_URL,
  };
};

export const copyDoctorOnboardingURL = () => {
  return {
    type: COPY_DOCTOR_ONBOARD_URL,
  };
};

export const clearDoctorOnboardingURL = () => {
  return {
    type: CLEAR_DOCTOR_ONBOARD_URL,
  };
};

export const filterDoctors = (search_key, search_value, page) => {
  return (dispatch) => {
    dispatch({
      type: FILTER_DOCTORS,
      payload: { key: search_key, value: search_value, page: page },
    });
    dispatch(startLoader());
  };
};

export const filterDoctorsSuccess = (data) => {
  return {
    type: FILTER_DOCTORS_SUCCESS,
    payload: data,
  };
};

export const updateExcludeDoctorForDR = (payload) => {
  return (dispatch) => {
    dispatch({
      type: UPDATE_EXCLUDE_DOCTORS_FOR_DOCTOR_REPORTS,
      payload: payload,
    });
  };
};

export const updateDoctorStatus = (payload) => {
  return {
    type: UPDATE_DOCTOR_STATUS,
    payload: payload,
  };
};

export const updateDoctorStatusSuccess = (payload) => {
  return {
    type: UPDATE_DOCTOR_STATUS_SUCCESS,
    payload: payload
  };
};

export const updateDoctorAccountStatus = (payload) => {
  return {
    type: UPDATE_DOCTOR_ACCOUNT_STATUS,
    payload: payload,
  };
};